import { Link } from "react-router-dom";
import { Lock, Sparkles, Percent } from "lucide-react";
import { Button } from "@/components/ui/button";

export function UpgradeGate({ title, note, cta = "View memberships", testId = "upgrade-gate" }) {
  return (
    <div className="max-w-lg mx-auto text-center py-20" data-testid={testId}>
      <div className="w-14 h-14 rounded-full bg-accent/10 border border-accent/30 flex items-center justify-center mx-auto">
        <Lock className="w-6 h-6 text-accent" strokeWidth={1.5} />
      </div>
      <h2 className="font-display text-3xl font-medium mt-6">{title}</h2>
      <p className="text-muted-foreground mt-3">{note}</p>
      <Link to="/pricing"><Button className="rounded-full mt-6" data-testid="upgrade-cta"><Sparkles className="w-4 h-4 mr-2" />{cta}</Button></Link>
      <Link to="/pricing?cycle=yearly" className="block mt-4" data-testid="upgrade-annual-nudge">
        <span className="inline-flex items-center gap-1.5 font-mono-data text-[11px] uppercase tracking-wider text-accent hover:opacity-80 transition-opacity">
          <Percent className="w-3.5 h-3.5" /> Save 20% with annual membership
        </span>
      </Link>
    </div>
  );
}
